import { IconCheck as Check } from '@tabler/icons-react';

export type LotteryRulesTimelineGroup = {
  time: string;
  allCompleted: boolean;
  rules: Array<{
    id?: string | null;
    lotteryTime?: Date | string | null;
    prize?: { name?: string | null } | null;
    winnerCount?: number | null;
  }>;
};

/**
 * 抽奖规则时间轴：HeroUI v3 无 Timeline 组件时的轻量替代（竖线与节点）。
 */
export function LotteryRulesTimeline({ groups }: { groups: LotteryRulesTimelineGroup[] }) {
  return (
    <div className="mt-4 ml-1 space-y-6 border-l-2 border-divider pl-5">
      {groups.map((group, groupIndex) => (
        <div key={group.time || String(groupIndex)} className="relative">
          <div
            className={`absolute -left-[calc(1.25rem+1px)] top-0.5 flex size-4 shrink-0 items-center justify-center rounded-full border-2 bg-background ${
              group.allCompleted
                ? '!border-green-500 !bg-green-50 dark:!bg-green-950/50'
                : 'border-default-300'
            }`}
          >
            {group.allCompleted ? (
              <Check className="size-2.5 text-green-600 dark:text-green-400" />
            ) : null}
          </div>
          <time
            className="mb-2 block text-sm font-medium text-foreground"
            {...(group.rules[0]?.lotteryTime
              ? { dateTime: new Date(group.rules[0].lotteryTime).toISOString() }
              : {})}
          >
            {group.time || '—'}
          </time>
          <div className="space-y-2">
            {group.rules.map((rule, ruleIndex) => (
              <div
                key={rule.id ?? ruleIndex}
                className="flex items-center justify-between py-1"
              >
                <span className="text-sm text-foreground">{rule.prize?.name ?? '未知奖品'}</span>
                {rule.winnerCount != null && (
                  <span className="text-sm text-default-500">{rule.winnerCount}个</span>
                )}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
